import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axiosAuth from '@/axios-auth';
import axios from 'axios';
import fs, { Stats } from 'fs';
import _ from 'lodash'; //Para ordenamiento de arreglos.
import { push } from 'core-js/fn/array';
import { strictEqual } from 'assert';
import { prependListener } from 'process';
// import path from 'path';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        version: '1.1.2',
        appTitle: 'Mascotas - Tus documentos',
        logo1: require('@/assets/logo1.png'),
        mainBackgroundImg: '../assets/floriane-vita-FyD3OWBuXnY-unsplash.jpg',
        bWaitCursor: false,
        bFailedLogin: false,
        isAuthenticated: false,
        bInactiveUser: false,

        userName: '', //Nombre del usuario logueado.

        bAdmin: false,
        //authHeader: null,
        idToken: null,
        userID: null,
        //userType: 0, //1 = superadmin, 2 = admin. prepago, 3 = admin. de seguimiento, 4 = encuestado.

        user: null,
        users: null,
        administrators: null,
        clients: null,
        campaigns: null,
        campaignImage: null, //Imagen de la campaña selecionada en la ventana Publicidad.

        bDuplicatedUserError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar a un usuario con un correo previamente registrado.
        bDuplicatedSpeciesError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar a una especie previamente registrada.
        bDuplicatedClientError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar a un cliente con la misma razón social.
        bDuplicatedCampaignError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar una campaña con el mismo nombre.

        userTypes: [], //Tipos de usuario administrador (súper admin, administrador de veterinarias y administrador de vacunas).
        selectedUserTypeIndex: -1,

        languages: [],
        selectedLanguageIndex: -1, //Indice del idioma seleccionado en la ventana Idiomas.
        bSearchNewLanguage: false, //Indica si se debe buscar el índice del idioma que se acaba de registrar.
        newLanguageName: '', //Indica el nombre de un nuevo idioma registrado, para poder seleccionarlo después en la ventana Idiomas.

        countries: [],
        states: [],
        specialties: [],

        bServerResponse: false, //Indica si el servidor ya respondió ante un request de borrado de cuestionario.

        bSearchNewUser: false, //Indica si se debe buscar el índice del usuario que se acaba de registrar.
        bSearchNewClient: false, //Indica si se debe buscar el índice del cliente que se acaba de registrar.

        bSearchNewCampaign: false, //Indica si se debe buscar el índice de la campaña que se acaba de registrar.
        bNewCampaignID: 0,
        newCampaignName: '',
        selectedCampaignIndex: -1,

        bSearchNewSpecies: false,
        newSpeciesID: 0,
        selectNewSpecies: false, //Indica si ya se recibió la lista de todas las especies, para que se pueda seleccionar la nueva.
        newSpeciesName: '', //Indica el nombre de una nueva especie registrada.

        newUserEmail: '', //Indica el email de un nuevo usuario registrado, para poder seleccionarlo después en la ventana Usuarios.
        newClientName: '', //Indica el nombre de un nuevo cliente registrado, para poder seleccionarlo después en la ventana ClintesPublicidad.

        selectedUserIndex: -1, //Indice del usuario seleccionado en la ventana Usuarios.
        selectedSpeciesIndex: -1, //Indice de la especie seleccionada en la ventana Especies.vue.
        selectedClientIndex: -1, //Indice del cliente seleccionado en la ventana ClientesPublicidad

        species: [],

        bLoadingData: false, //Indica si la información de la BD está siendo cargada, para no dejar cambiarse a ninguna otro plan o materia antes de que se reciba toda la información.

        speciesTableHeader: [], //Header de la tabla de especies-idiomas, para la ventana Especies.vue
        speciesNameTable: [],
        speciesNames: [], //Arreglo con el nombre de la especie seleccionada en todos los idiomas, para Especies.vue.
        breedsLang: [],
        breedTable: [],
        breedsSpanish: [], //Razas en español de la especie seleccionada.

        vets: [], //Arreglo de clínicas veterinarias resultado de una búsqueda.
        vetsLoaded: false, //Indica que el servidor ya regresó un arreglo de veterinarias resultado de una búsqueda.
        bDlgSearchNewVet: false, //Indica que se debe desplegar el modal para buscar una nueva veterinaria.
        bDlgEditVet: false, //Indica que se debe desplegar el modal para editar una nueva veterinaria.
        bDlgAddVet: false, //Indica que se debe desplegar el modal para registrar una nueva veterinaria.

        petSearchResults: [],
        bShowPetDlg: false,
        bShowVaxDlg: false,
        bShowDespDlg: false,

        petID: 0, //Mascota seleccionada

        pet: {
            fechaRegistro: '',
            numeroUsuario: 0,
            tipoUsuario: '',
            pais: '',
            estado: '',
            especie: '',
            raza: '',
            sexo: '',
            edad: '',
            esterilizado: false
        },

        petQRInfo: {
            petName: '',
            ownerName: '',
            phone: '',
            esterilizada: 0,
            notaPlaca: ''
        },

        petQRInfoLoaded: false,
        petQRError: 0,
        messageToOwnerRes: 0, //0 = waiting, 1 = success, 2 = error.

        petVaxes: [],
        petDewormings: [],
        petDentalCleanings: [],
        petOtherProcedures: [],

        vaxImg: null,
        despImg: null,

        vaxDlgWidth: '60%',
        despDlgWidth: '60%'
    },

    mutations: {
        setFailedLogin(state, payload) {
            state.bFailedLogin = payload;
        },
        setInactiveUser(state, payload) {
            state.bInactiveUser = payload;
        },
        authUser(state, userData) {
            //state.authHeader = userData.authHeader;
            state.idToken = userData.idToken;
            state.userID = userData.userID;
        },
        clearAuthData(state) {
            //state.authHeader = null,
            console.log('clearAuthData...');

            state.idToken = null;
            state.userID = null;
            state.isAuthenticated = false;
        },
        setDuplicatedUserError(state, payload) {
            state.bDuplicatedUserError = payload;
        },
        setDuplicatedSpeciesError(state, payload) {
            state.bDuplicatedSpeciesError = payload;
        },
        setDuplicatedClientError(state, payload) {
            state.bDuplicatedClientError = payload;
        },
        setDuplicatedCampaignError(state, payload) {
            state.bDuplicatedCampaignError = payload;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUser(state, user) {
            state.user = user;
            state.userName = user.nombre + ' ' + user.appaterno + ' ' + user.apmaterno;
            //state.semestre = user.semestre;

            if (state.user.tipoid === 1) {
                //Administrador
                state.bAdmin = true;
            } //Alumno
            else {
                state.bAdmin = false;
            }
        },

        setLoadingData(state, bLoading) {
            state.bLoadingData = bLoading;
        },

        setUserTypes(state, userTypes) {
            state.bWaitCursor = true;
            state.userTypes = userTypes;
            state.bWaitCursor = false;
        },

        setServerResponse(state, bResponse) {
            state.bServerResponse = bResponse;
        },

        setVets(state, vets) {
            state.bWaitCursor = true;
            state.vets = vets;
            state.bWaitCursor = false;
        },

        setVetsLoaded(state, payload) {
            state.bWaitCursor = true;
            state.vetsLoaded = payload;
            state.bWaitCursor = false;
        },

        setUsers(state, users) {
            if (state.users !== null) {
                state.users.length = 0;
            }

            state.bWaitCursor = true;
            state.users = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].email) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                        break;
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setAdministrators(state, users) {
            if (state.administrators !== null) {
                state.administrators.length = 0;
            }

            state.bWaitCursor = true;
            state.administrators = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].correo) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setLanguages(state, languages) {
            state.bWaitCursor = true;
            state.languages = languages;

            if (state.bSearchNewLanguage) {
                var i;
                for (i = 0; i < languages.length; i++) {
                    if (state.newLanguageName === languages[i].idioma) {
                        state.selectedLanguageIndex = i;
                        state.bSearchNewLanguage = false;
                        state.newLanguageName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setClients(state, clients) {
            if (state.clients !== null) {
                state.clients.length = 0;
            }

            state.bWaitCursor = true;
            state.clients = clients;

            var i;
            for (i = 0; i < clients.length; i++) {
                if (state.bSearchNewClient) {
                    if (state.newClientName === clients[i].nombre) {
                        state.selectedClientIndex = i;
                        state.bSearchNewClient = false;
                        state.newClientName = '';
                        break;
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setCampaigns(state, campaigns) {
            if (state.campaigns !== null) {
                state.campaigns.length = 0;
            }

            state.bWaitCursor = true;
            state.campaigns = campaigns;

            var i;
            for (i = 0; i < campaigns.length; i++) {
                if (state.bSearchNewCampaign) {
                    if (state.newCampaignName === campaigns[i].nombre) {
                        state.selectedCampaignIndex = i;
                        state.bSearchNewCampaign = false;
                        state.newCampaignName = '';
                        break;
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setCampaignImage(state, img) {
            state.campaignImage = img;
        },

        updateSelectedCampaignIndex: (state, index) => {
            state.selectedCampaignIndex = index;
        },

        updateSelectedLanguageIndex: (state, index) => {
            state.selectedLanguageIndex = index;
        },

        setCountries(state, countries) {
            state.bWaitCursor = true;
            state.countries = countries;
            state.bWaitCursor = false;
        },

        setStates(state, cities) {
            state.bWaitCursor = true;
            state.states = cities;
            state.bWaitCursor = false;
        },

        setSpecialties(state, specialties) {
            state.bWaitCursor = true;
            state.specialties = specialties;
            state.bWaitCursor = false;
        },

        addNewUser(state, newUser) {
            state.users.push(newUser);
        },
        addNewAdministrator(state, newUser) {
            state.administrators.push(newUser);
        },
        updateSelectedUserIndex: (state, index) => {
            state.selectedUserIndex = index;
        },
        updateSelectedClientIndex: (state, index) => {
            state.selectedClientIndex = index;
        },
        updateSelectedSpeciesIndex: (state, index) => {
            state.selectedSpeciesIndex = index;
        },
        updateSelectedPlanIndex: (state, index) => {
            state.selectedPlanIndex = index;
        },

        setSpecies(state, species) {
            if (state.species !== null) {
                state.species.length = 0;
            }

            state.bWaitCursor = true;
            state.species = species;

            for (let i = 0; i < species.length; i++) {
                if (state.bSearchNewSpecies) {
                    if (state.newSpeciesName === species[i].especie) {
                        state.selectedSpeciesIndex = i;
                        state.bSearchNewSpecies = false;
                        state.newSpeciesName = '';
                        break;
                    }
                }
            }

            //Si hay una especie nueva, ya se puede seleccionar:
            if (state.newSpeciesID !== 0) {
                state.selectNewSpecies = true;
            }

            state.bWaitCursor = false;
        },

        setNewSpeciesID(state, speciesID) {
            state.bWaitCursor = true;
            state.newSpeciesID = speciesID;
            state.bWaitCursor = false;
        },

        setSelectNewSpecies(state, payload) {
            state.bWaitCursor = true;
            state.selectNewSpecies = payload;
            state.bWaitCursor = false;
        },

        setSpeciesNameTable(state, speciesNameTable) {
            state.speciesNameTable = speciesNameTable;
        },

        setSpeciesTableHeader(state, speciesHeader) {
            state.speciesTableHeader = speciesHeader;
        },

        setSpeciesNames(state, speciesNames) {
            state.bWaitCursor = true;
            state.speciesNames = speciesNames;
            state.bWaitCursor = false;
        },

        setBreedsLang(state, breedsLang) {
            state.bWaitCursor = true;
            state.breedsLang = breedsLang;
            state.bWaitCursor = false;
        },

        setBreedTable(state, breedTable) {
            state.bWaitCursor = true;
            state.breedTable = breedTable;
            state.bWaitCursor = false;
        },

        setDlgSearchNewVet(state, payload) {
            state.bDlgSearchNewVet = payload;
        },

        setDlgEditVet(state, payload) {
            state.bDlgEditVet = payload;
        },

        setDlgAddVet(state, payload) {
            state.bDlgAddVet = payload;
        },

        setBreedsSpanish(state, breeds) {
            state.breedsSpanish = breeds;
        },

        setPetSearchResults(state, results) {
            state.bWaitCursor = true;
            state.petSearchResults = results;
            state.bWaitCursor = false;
        },

        setPetID(state, id) {
            state.petID = id;
        },

        setPet(state, pet) {
            state.bWaitCursor = true;
            state.pet = pet;
            state.bWaitCursor = false;
        },

        setPetQRInfo(state, petInfo) {
            state.bWaitCursor = true;
            state.petQRInfo = petInfo;
            state.petQRInfoLoaded = true;
            state.bWaitCursor = false;
        },

        setPetQRInfoLoaded(state, payload) {
            state.petQRInfoLoaded = payload;
        },

        setPetQRError(state, payload) {
            state.petQRError = payload;
        },

        setPetVaxes(state, vaxes) {
            state.bWaitCursor = true;
            state.petVaxes = vaxes;
            state.bWaitCursor = false;
        },

        setPetDewormings(state, dewormings) {
            state.bWaitCursor = true;
            state.petDewormings = dewormings;
            state.bWaitCursor = false;
        },

        setPetDentalCleanings(state, dentalCleanings) {
            state.bWaitCursor = true;
            state.petDentalCleanings = dentalCleanings;
            state.bWaitCursor = false;
        },

        setPetOtherProcedures(state, otherProcedures) {
            state.bWaitCursor = true;
            state.petOtherProcedures = otherProcedures;
            state.bWaitCursor = false;
        },

        setShowPetDlg(state, payload) {
            state.bShowPetDlg = payload;
        },

        setShowVaxDlg(state, payload) {
            state.bShowVaxDlg = payload;
        },

        setShowDespDlg(state, payload) {
            state.bShowDespDlg = payload;
        },

        setVaxImg(state, img) {
            state.vaxImg = img;
        },

        setDespImg(state, img) {
            state.despImg = img;
        },

        setVaxDlgWidth(state, width) {
            state.vaxDlgWidth = width;
        },

        setDespDlgWidth(state, width) {
            state.despDlgWidth = width;
        },

        setMessageToOwnerRes(state, payload) {
            state.messageToOwnerRes = payload;
        }
    },
    actions: {
        login({ commit, dispatch, state }, authData) {
            state.bWaitCursor = true;

            var bAdmin = false;

            //Autenticación en Jocoque:
            axiosAuth
                .post('/users/login/', null, {
                    params: {
                        user: authData.email,
                        password: authData.password
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Autenticación OK, res = ', res);
                    var user = res.data;
                    if (user.error === 0) {
                        var idToken = user.token.slice(7);

                        commit('authUser', { idToken: idToken, userID: user.usuarioid });

                        commit('setIsAuthenticated', true);

                        commit('setUser', user);

                        dispatch('fetchAdminConfigData');

                        const now = new Date();
                        const expirationDate = new Date(now.getTime() + res.data.expiresin * 1000); //Con getTime() se obtiene el tiempo en milisegundos
                        console.log('ExpirationDate = ', expirationDate);

                        //localStorage.setItem('authHeader', res.data.token)
                        //localStorage.setItem('token', res.data.idToken);
                        localStorage.setItem('token', idToken);
                        localStorage.setItem('userID', res.data.localId);
                        localStorage.setItem('expirationDate', expirationDate);
                        localStorage.setItem('userEmail', res.data.email);
                        dispatch('setLogoutTimer', res.data.expiresin);

                        state.bWaitCursor = false;
                        //router.push('/');
                        router.push('/').catch(err => {});
                    } else if (user.error === 3) {
                        //Usuario Inactivo...
                        state.bWaitCursor = false;
                        commit('setIsAuthenticated', false);
                        commit('setInactiveUser', true);
                    } //Error en nombre de usuario o password...
                    else {
                        console.log('Error de autenticación #', user.error);
                        state.bWaitCursor = false;
                        //commit('clearAuthData');
                        commit('setIsAuthenticated', false);
                        commit('setFailedLogin', true);
                    }
                })
                .catch(error => {
                    console.log('Error de autenticación #0: ', error);
                    state.bWaitCursor = false;

                    //commit('clearAuthData');
                    commit('setIsAuthenticated', false);
                    commit('setFailedLogin', true);
                });
            //}
        },
        updateFailedLogin({ commit }, failedLogin) {
            commit('setFailedLogin', failedLogin);
        },
        updateInactiveUser({ commit }, inactiveUser) {
            commit('setInactiveUser', inactiveUser);
        },
        setLogoutTimer({ commit }, expirationTime) {
            setTimeout(() => {
                console.log('Llamando a clearAuthData desde setLogoutTimer');
                commit('clearAuthData');
                router.replace('/sign-in'); //Aparentemente es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            }, expirationTime * 1000);
        },
        logout({ commit, state }) {
            axios.delete('/session/deleteSession/' + state.idToken); //Borra la sesión
            console.log('Llamando a clearAuthData desde logout');
            commit('clearAuthData');

            //localStorage.removeItem('authHeader');
            localStorage.removeItem('token');
            localStorage.removeItem('userID');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('userEmail');
            //router.replace('/sign-in');//Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            router.replace('/sign-in').catch(err => {}); //Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
        },
        tryAutoLogin({ commit, dispatch }) {
            console.log('TryAutoLogin...');
            const token = localStorage.getItem('token');
            if (!token) {
                console.log('No hay token...');
                return;
            }

            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            const now = new Date();

            if (now >= expirationDate) {
                console.log('Time has expired...');
                return;
            }
            const userID = localStorage.getItem('userID');
            this.commit('authUser', {
                //authHeader: authHeader,
                idToken: token,
                userID: userID
            });

            const userEmail = localStorage.getItem('userEmail');
            commit('setIsAuthenticated', true);

            //Carga al usuario logueado:
            dispatch('userAutoLogin', userEmail);

            router.push('/').catch(err => {});
        },
        userAutoLogin({ commit, dispatch, state }, email) {
            if (!state.idToken) {
                return;
            }

            axios
                .get('/users/getByEmail/' + email + '/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de userAutoLogin: ', res);

                    //error 0 = No hay error.
                    if (res.data.error === 1) {
                        console.log('Error. Sesión no válida.');
                        dispatch('logout');
                    } else {
                        const user = res.data;
                        console.log('user = ', user);

                        commit('setUser', user);

                        dispatch('fetchAdminConfigData');
                    }
                })
                .catch(error => {
                    alert('Error en login: ' + error);
                    console.log('Error en login: ', error);
                    dispatch('logout');
                });
        },

        fetchAdminConfigData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }
            dispatch('fetchUserTypes');
            dispatch('fetchUsers');
            dispatch('fetchLanguages');
            dispatch('fetchCountries');
            dispatch('fetchSpecialties');
            dispatch('fetchSpecies');
            dispatch('fetchClients');
            dispatch('fetchCampaigns');
        },

        fetchUserTypes({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/userType/getTiposUsuario/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchUserTypes, res = ', res);
                    const userTypes = res.data;
                    state.bWaitCursor = false;
                    commit('setUserTypes', userTypes);
                })
                .catch(error => {
                    console.log('Error en fetchUserTypes, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchLanguages({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/languages/getLanguages/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchLanguages, res = ', res);
                    const data = res.data;
                    const languages = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const language = data[i];
                        languages.push(language);
                    }
                    state.bWaitCursor = false;
                    commit('setLanguages', languages);
                })
                .catch(error => {
                    console.log('Error en FetchLanguages, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateSelectedLanguageIndex({ commit }, index) {
            commit('updateSelectedLanguageIndex', index);
        },
        saveNewLanguage({ dispatch, state }, newLanguage) {
            if (!state.idToken) {
                return;
            }
            //console.log("Language to save: ", newLanguage);

            state.bWaitCursor = true;
            state.bSearchNewLanguage = true;
            state.newLanguageName = newLanguage.idioma;

            axios
                .post('/idiomas/' + state.idToken, newLanguage)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewLanguage = false;
                });
        },
        updateLanguage({ dispatch, state }, language) {
            if (!state.idToken) {
                return;
            }
            console.log('Language to save: ', language);

            state.bWaitCursor = true;
            state.bSearchNewLanguage = true;
            state.newLanguageName = language.idioma;

            axios
                .post('/idiomas/' + language.idiomaid + '/' + state.idToken, language)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewLanguage = false;
                });
        },
        deleteLanguage({ dispatch, state }, idiomaID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/idiomas/deleteIdioma/' + idiomaID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        fetchCountries({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/countries/getCountries/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchCuntries, res = ', res);
                    const data = res.data;
                    const contries = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const country = data[i];
                        contries.push(country);
                    }
                    state.bWaitCursor = false;
                    commit('setCountries', contries);
                })
                .catch(error => {
                    console.log('Error en FetchCountries, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchStates({ commit, state }, countryID) {
            state.bWaitCursor = true;

            axios
                .get('/states/getStates/' + countryID + '/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchStates, res = ', res);
                    const data = res.data;
                    const states = [];
                    commit('setStates', states);
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const state = data[i];
                        states.push(state);
                    }
                    state.bWaitCursor = false;
                    commit('setStates', states);
                })
                .catch(error => {
                    console.log('Error en FetchStates, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSpecialties({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/specialists/getSpecialists/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('fetchSpecialties, res = ', res);
                    const data = res.data;
                    const specialties = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const specialty = data[i];
                        specialties.push(specialty);
                    }
                    state.bWaitCursor = false;
                    commit('setSpecialties', specialties);
                })
                .catch(error => {
                    console.log('Error en fetchSpecialties, error = ', error);
                    state.bWaitCursor = false;
                });

            /*const specialties = [
                {
                    especialidad: 'General',
                    especialidadid: 1
                },
                {
                    especialidad: 'Perros y gatos',
                    especialidadid: 2
                },
                {
                    especialidad: 'Perros',
                    especialidadid: 3
                },
                {
                    especialidad: 'Gatos',
                    especialidadid: 4
                },
                {
                    especialidad: 'Aves',
                    especialidadid: 5
                },
                {
                    especialidad: 'Otros',
                    especialidadid: 6
                }
            ];
            commit('setSpecialties', specialties);*/
        },

        fetchVets({ dispatch, state }, searchData) {
            state.bWaitCursor = true;

            axios
                .get(
                    '/vet/getVets/' +
                        searchData.paisid +
                        '/' +
                        searchData.estadoid +
                        '/' +
                        searchData.especialidadid +
                        '/' +
                        state.idToken,
                    {
                        crossDomain: true
                    }
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de fetchVets = ', res);
                    var vets = res.data;
                    dispatch('updateVets', vets);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en fetchVets, error = ', error);
                    state.bWaitCursor = false;
                });

            //Pruebas:
            // var vets = [
            //     {
            //         veterinariaid: 1,
            //         nombre: 'Clínica Dr. Casaubón Del Valle',
            //         especialidadid: 1,
            //         rating: 5,
            //         direccion: 'Avenida Coyoacán 753-C, Colonia del Valle Centro, Ciudad de México',
            //         lat: '19.3851858',
            //         lng: '-99.16779009999999',
            //         comentarios: '',
            //         horario: '10:00 a 18:00'
            //     },
            //     {
            //         veterinariaid: 2,
            //         nombre: 'Kalimax Mascotas',
            //         especialidadid: 2,
            //         rating: 5,
            //         direccion: 'Matías Romero 105, Colonia del Valle Centro, Ciudad de México',
            //         lat: '19.3810611',
            //         lng: '-99.1702303',
            //         comentarios: '',
            //         horario: '9:00 a 20:00'
            //     },
            //     {
            //         veterinariaid: 3,
            //         nombre: 'Centro de Biotecnología Veterinaria',
            //         especialidadid: 1,
            //         rating: 4,
            //         direccion: 'Gabriel Mancera Eje 2 403, Colonia del Valle Centro, Benito Juárez',
            //         lat: '19.3801037',
            //         lng: '-99.1658075',
            //         comentarios: '',
            //         horario: '9:00 a 18:00'
            //     },
            //     {
            //         veterinariaid: 4,
            //         nombre: 'Veterinaria Pets Imaginarium Centro de Nutrición y Conducta',
            //         especialidadid: 2,
            //         rating: 5,
            //         direccion: 'José Enrique Pestalozzi 1232, Colonia Del Valle, Ciudad de México',
            //         lat: '19.3781419',
            //         lng: '-99.161439',
            //         comentarios: '',
            //         horario: '10:00 a 18:00'
            //     },
            //     {
            //         veterinariaid: 5,
            //         nombre: 'Pet Station',
            //         especialidadid: 1,
            //         rating: 5,
            //         direccion: 'Heriberto Frías 841, Narvarte Poniente, Ciudad de México',
            //         lat: '19.3869932',
            //         lng: '-99.1611387',
            //         comentarios: '',
            //         horario: '10:30 a 19:00'
            //     }
            //];
            //
            //dispatch('updateVets', vets);
            //dispatch('updateVetsLoaded', true);

            //Fin Pruebas
        },

        updateVets({ dispatch, commit, state }, vets) {
            if (!state.idToken) {
                return;
            }
            commit('setVets', vets);
            dispatch('updateVetsLoaded', true);
        },

        updateVetsLoaded({ commit, state }, payload) {
            commit('setVetsLoaded', payload);
        },

        editVet({ commit, state }, vet) {
            state.bWaitCursor = true;

            console.log('Vet to edit: ', vet);

            //Pendiente:
            axios
                .post('/vet/modifyVet/' + state.idToken, vet)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de Edición de Veterinaria: ', res);
                    //Pendiente: tal vez sea necesario que el servidor regrese un valor para
                    //saber si la veterinaria se registró con éxito, y con base en esto desplegar
                    //un mensaje, ya que en este momento no se va a refrescar la lista de
                    //todas las veterinarias, como se hace cuando se editan otros tipos de registros.
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        newVet({ commit, state }, vet) {
            state.bWaitCursor = true;

            console.log('Vet to save: ', vet);

            axios
                .post('/vet/' + state.idToken, vet)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de Registro de Veterinaria: ', res);
                    //Pendiente: tal vez sea necesario que el servidor regrese un valor para
                    //saber si la veterinaria se registró con éxito, y con base en esto desplegar
                    //un mensaje, ya que en este momento no se va a refrescar la lista de
                    //todas las veterinarias, como se hace cuando se editan otros tipos de registros.
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        deleteVet({ dispatch, state }, vetID) {
            state.bWaitCursor = true;

            axios
                .delete('vet/deleteVet/' + vetID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('deleteVet, res = ', res);

                    //Borra localmente la veterinaria que se borró:
                    for (let i = 0; i < state.vets.length; i++) {
                        if (state.vets[i].veterinariaid === vetID) {
                            state.vets.splice(i, 1);
                            break;
                        }
                    }
                    dispatch('updateVetsLoaded', true); //Para actualizar los marcadores del mapa.
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchSpecies({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/species/getAllSpecies/1/' + state.idToken, { crossDomain: true }) //getAllSpecies/1/ = español, /2 = inglés
                .then(res => {
                    console.log('fetchSpecies, res = ', res);
                    const species = res.data;
                    state.bWaitCursor = false;
                    commit('setSpecies', species);
                })
                .catch(error => {
                    console.log('Error en fetchSpecies, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateLoadingData({ commit }, bLoading) {
            commit('setLoadingData', bLoading);
        },

        updateServerResponse({ commit }, bResponse) {
            commit('setServerResponse', bResponse);
        },

        fetchUsers({ commit, state }) {
            //En esta función se obtienen los usuarios administradores.
            state.bWaitCursor = true;

            axios
                .get('/users/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchUsuarios: ', res);
                    const users = res.data;
                    commit('setUsers', users);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchClients({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/clients/getAllClients/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchClients: ', res);
                    const clients = res.data;
                    commit('setClients', clients);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:

            /*var clients = [
                {
                    clienteid: 1,
                    nombre: 'Bayer AG Inc',
                    rfc: 'BAY940820-2AV',
                    contacto: 'Juan Pérez González',
                    telefono1: '55-5555-5555',
                    telefono2: '55-4444-4444',
                    email: 'juan@bayern.com',
                    notas: 'Estas son las notas de la empresa Bayer'
                },
                {
                    clienteid: 2,
                    nombre: 'Petco, S.A. de C.V.',
                    rfc: 'NES591007-3XU',
                    contacto: 'Pepe Pérez Peralta',
                    telefono1: '55-333-3333',
                    telefono2: '55-2222-2222',
                    email: 'pepe@nestle.com',
                    notas: 'Estas son las notas de la empresa Nestlé'
                }
            ];

            commit('setClients', clients);
            state.bWaitCursor = false;*/

            //Fin pruebas.
        },

        fetchCampaigns({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/campaigns/getAllCampaigns/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchCampaigns: ', res);
                    const campaigns = res.data;
                    commit('setCampaigns', campaigns);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });

            //Inicio pruebas:

            /*var campaigns = [
                {
                    campanaid: 1,
                    numero: 1,
                    nombre: 'Bayer 2023-1',
                    clienteid: 1,
                    etiqueta: '¡Oferta de medicamentos!',
                    fechaRegistro: '2023/05/18',
                    fechaInicio: '2023/05/20',
                    fechaFin: '2023/06/20',
                    url: 'www.google.com',
                    notas: 'Estas son las notas de la campaña de Bayer.',
                    imagen: {
                        id: null
                    }
                },
                {
                    campanaid: 2,
                    numero: 2,
                    nombre: 'Proplán 2023-1',
                    clienteid: 2,
                    etiqueta: 'Súper oferta de croquetas',
                    fechaRegistro: '2023/05/15',
                    fechaInicio: '2023/06/01',
                    fechaFin: '2023/08/31',
                    url: 'www.gtsf.com.mx',
                    notas: 'Estas son las notas de la campaña de Proplán.',
                    imagen: {
                        id: null
                    }
                }
            ];

            commit('setCampaigns', campaigns);
            state.bWaitCursor = false;
            */
            //Fin pruebas.
        },

        async getCampaignImage({ commit, state }, imageInfo) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/downloadFile/' + imageInfo + '/' + state.idToken, {
                    crossDomain: true,
                    responseType: 'blob'
                })
                .then(res => {
                    //console.log('getCampaignImage, res = ', res);
                    state.bWaitCursor = false;
                    let imgFile = new File([res.data], imageInfo.fileName, {
                        type: imageInfo.fileType
                    });
                    var imgFileURL = URL.createObjectURL(imgFile);

                    commit('setCampaignImage', imgFileURL);
                })
                .catch(error => {
                    console.log('Error en getCampaignImage, error = ', error);
                    let imgFileURL = require('@/assets/no-image.png');
                    commit('setCampaignImage', imgFileURL);
                    state.bWaitCursor = false;
                });
        },

        setDuplicatedUserError({ commit }, payload) {
            commit('setDuplicatedUserError', payload);
        },

        setDuplicatedSpeciesError({ commit }, payload) {
            commit('setDuplicatedSpeciesError', payload);
        },

        setDuplicatedClientError({ commit }, payload) {
            commit('setDuplicatedClientError', payload);
        },

        setDuplicatedCampaignError({ commit }, payload) {
            commit('setDuplicatedCampaignError', payload);
        },

        saveNewUser({ dispatch, state }, newUser) {
            //Checa que no haya un usuario registado con el mismo correo:

            state.bWaitCursor = true;
            console.log('email: ', newUser.email);

            axios
                .get('/users/getByEmail/' + newUser.email + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    const data = res.data;
                    console.log('New User, res = ', data);
                    if (data.usuarioid === 0) {
                        //No se encontró un usuario con ese correo...
                        //console.log("Todo bien, podemos registrar usuario...");
                        dispatch('storeNewUser', newUser);
                    } //Ya hay un usuario con ese correo...
                    else {
                        dispatch('setDuplicatedUserError', true);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        saveNewSpecies({ dispatch, state }, newSpecies) {
            //Checa que no haya una especie registada con el mismo nombre:

            state.bWaitCursor = true;
            state.bSearchNewSpecies = true;

            //Busca el nombre de la nueva especie en español:
            var spanishID = 0;
            for (var i = 0; i < state.languages.length; i++) {
                if (state.languages[i].idioma === 'Español') {
                    spanishID = state.languages[i].idiomaid;
                    break;
                }
            }

            for (var i = 0; i < newSpecies.especie.length; i++) {
                if (newSpecies.especie[i].idiomaid === spanishID) {
                    state.newSpeciesName = newSpecies.especie[i].especie;
                    break;
                }
            }

            //Pendiente: checar si se va a revisar que no se haya registrado antes:
            axios
                .post('/species/' + state.idToken, newSpecies)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('New Species, res.data = ', res.data);
                    //Obtiene el ID de la nueva especie, para poder seleccionarla en Especies.vue:
                    state.newSpeciesID = res.data.especieid;
                    console.log('state.newSpeciesID = ', state.newSpeciesID);
                    dispatch('fetchSpecies');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewSpecies = false;
                });
        },

        updateNewSpeciesID({ commit, state }, speciesID) {
            if (!state.idToken) {
                return;
            }
            commit('setNewSpeciesID', speciesID);
        },

        updateSelectNewSpecies({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setSelectNewSpecies', payload);
        },

        updateSpeciesNames({ dispatch, state }, speciesToEdit) {
            state.bWaitCursor = true;
            state.bSearchNewSpecies = true;

            //Busca el nombre de la nueva especie en español:
            var spanishID = 0;
            for (var i = 0; i < state.languages.length; i++) {
                if (state.languages[i].idioma === 'Español') {
                    spanishID = state.languages[i].idiomaid;
                    break;
                }
            }

            //console.log('speciesToEdit = ', speciesToEdit);

            for (var i = 0; i < speciesToEdit.especieidiomas.length; i++) {
                if (speciesToEdit.especieidiomas[i].idiomaid === spanishID) {
                    state.newSpeciesName = speciesToEdit.especieidiomas[i].especie;
                    break;
                }
            }

            //Pendiente: checar si se va a checar que no se haya registrado antes:
            axios
                .post('/species/modifySpecies/' + state.idToken, speciesToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('UpdateSpeciesNames, res = ', res.data);
                    dispatch('fetchSpecies');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewSpecies = false;
                });
        },

        saveNewBreed({ dispatch, state }, newBreed) {
            state.bWaitCursor = true;
            //Pendiente: checar si se va a revisar que no se haya registrado antes:
            axios
                .post('/breed/' + state.idToken, newBreed)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('SaveNewBreed, res = ', res);
                    //Se llama a getSpeciesData para que la tabla de razas se vuelva a generar:
                    dispatch('getSpeciesData', newBreed.especieid);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        deleteBreed({ dispatch, state }, breedToDelete) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .delete('/breed/deleteBreeds/' + breedToDelete.breedID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('deleteBreed, res = ', res);
                    //Se llama a getSpeciesData para que la tabla de razas se vuelva a generar:
                    dispatch('getSpeciesData', breedToDelete.speciesID);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        updateBreed({ dispatch, state }, breedToEdit) {
            state.bWaitCursor = true;
            //Pendiente: checar si se va a revisar que no se haya registrado antes:
            axios
                .post('/breed/modifySpecies' + state.idToken, breedToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('updateBreed, res = ', res.data);
                    //Se llama a getSpeciesData para que la tabla de razas se vuelva a generar:
                    dispatch('getSpeciesData', breedToEdit.especieid);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        storeNewUser({ dispatch, state }, newUser) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewUser = true;
            state.newUserEmail = newUser.email;

            console.log('User to save: ', newUser);

            axios
                .post('/users/' + state.idToken, newUser)
                .then(res => {
                    state.bWaitCursor = false;
                    //console.log("res de storeNewUser: ", res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                    state.newUserEmail = '';
                });
        },

        saveNewClient({ dispatch, state }, newClient) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewClient = true;
            state.newClientName = newClient.name;

            console.log('Client to save: ', newClient);

            axios
                .post('/clients/' + state.idToken, newClient)
                .then(res => {
                    state.bWaitCursor = false;
                    //console.log("res de storeNewClient: ", res);
                    //Se vuelve a pedir al servidor todos los clientes:
                    dispatch('fetchClients');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewClient = false;
                    state.newClientName = '';
                });
        },

        storeNewCampaign({ dispatch, state }, newCampaign) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewCampaign = true;
            state.newCampaignName = newCampaign.name;

            console.log('Campaign to save: ', newCampaign);

            axios
                .post('/campaigns/' + state.idToken, newClient)
                .then(res => {
                    state.bWaitCursor = false;
                    //console.log("res de storeNewCampaign: ", res);
                    //Se vuelve a pedir al servidor todas las campañas:
                    dispatch('fetchCampaigns');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewCampaign = false;
                    state.newCampaignName = '';
                });
        },

        editUser({ dispatch, state }, user) {
            state.bWaitCursor = true;

            console.log('user = ', user);

            //Si el objeto user trae password quiere decir que hay que editar el password:
            console.log('user.password = ', user.password);
            if (user.password !== '') {
                //Cambia el password en la tabla de autenticación:
                console.log('Cambiando Password...');

                //Se crea un objeto con el ID y el password:
                const userPasswd = {
                    usuariosid: user.usuarioid,
                    password: user.password
                };

                axios
                    .post(
                        '/users/updateUserPassword/' + userPasswd.usuariosid + '/' + state.idToken,
                        userPasswd
                    )
                    .then(res => {
                        state.bWaitCursor = false;
                    })
                    .catch(error => {
                        console.log(error);
                        state.bWaitCursor = false;
                    });
            }

            //Edición de los datos del usuario:
            const userData = {
                usuarioid: user.usuarioid,
                activo: user.activo,
                email: user.email,
                nombre: user.nombre,
                appaterno: user.appaterno,
                apmaterno: user.apmaterno,
                empresaid: user.empresaid,
                tipoid: user.tipoid,
                cuestionarioid: user.cuestionarioid,
                numLicencias: user.numLicencias
            };
            console.log('user to save: ', userData);
            state.bWaitCursor = true;
            axios
                .post('/users/' + user.usuarioid + '/' + state.idToken, userData)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de Edición de Usuario: ', res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },

        editClient({ dispatch, state }, client) {
            state.bWaitCursor = true;

            console.log('client to save = ', client);

            state.bWaitCursor = true;
            axios
                .post('/clients/modifyClient/' + state.idToken, client)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de Edición de Cliente: ', res);
                    //Se vuelve a pedir al servidor todos los clientes:
                    dispatch('fetchClients');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewClient = false;
                });
        },

        editCampaign({ dispatch, state }, campaignToUpdate) {
            state.bWaitCursor = true;

            console.log('campaign to edit = ', campaignToUpdate);

            state.bWaitCursor = true;
            state.bSearchNewCampaign = true;
            state.newCampaignName = campaignToUpdate.campaign.nombre;

            axios
                .post('/campaigns/modifyCampaign/' + state.idToken, campaignToUpdate.campaign)
                .then(res => {
                    state.bWaitCursor = false;

                    if (campaignToUpdate.imageFile !== null) {
                        state.bWaitCursor = true;

                        let formData = new FormData();
                        formData.append('file', campaignToUpdate.imageFile);

                        axios
                            .post(
                                '/uploadFile/' +
                                    campaignToUpdate.campaign.campaniaid +
                                    '/4/' +
                                    state.idToken,
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                            )
                            .then(res => {
                                state.bWaitCursor = false;
                                console.log("'Image file uploaded!");
                                //Se vuelve a pedir al servidor todas las campañas:
                                dispatch('fetchCampaigns');
                            })
                            .catch(error => {
                                state.bWaitCursor = false;
                                console.log(error);
                            });
                    } else if (campaignToUpdate.deleteImage) {
                        state.bWaitCursor = true;
                        axios
                            .delete(
                                '/deleteFile/' +
                                    campaignToUpdate.campaign.campanaid +
                                    '/' +
                                    state.idToken
                            )
                            .then(res => {
                                console.log('DeleteFile, res = ', res);
                                state.bWaitCursor = false;
                                console.log('Image file deleted!');
                            })
                            .catch(error => {
                                state.bWaitCursor = false;
                                console.log(error);
                            });
                    }

                    //Se vuelve a pedir al servidor todas las campañas:
                    dispatch('fetchCampaigns');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewCampaign = false;
                });
        },

        saveNewCampaign({ dispatch, state }, newCampaign) {
            if (!state.idToken) {
                return;
            }
            console.log('Campaign to save: ', newCampaign);

            state.bWaitCursor = true;
            state.bSearchNewCampaign = true;
            state.newCampaignName = newCampaign.campaign.nombre;

            axios
                .post('/campaigns/' + state.idToken, newCampaign.campaign)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('SaveNewCampaign, res = ', res);

                    if (newCampaign.imageFile !== null) {
                        state.bWaitCursor = true;

                        let formData = new FormData();
                        formData.append('file', newCampaign.imageFile);

                        axios
                            .post(
                                '/uploadFile/' + res.data.campaniaid + '/4/' + state.idToken,
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                            )
                            .then(res => {
                                state.bWaitCursor = false;
                                console.log('Image file uploaded!');
                                //Se vuelve a pedir al servidor todas las campañas:
                                dispatch('fetchCampaigns');
                            })
                            .catch(error => {
                                state.bWaitCursor = false;
                                console.log(error);
                            });
                    } else {
                        //Se vuelve a pedir al servidor todas las campañas:
                        dispatch('fetchCampaigns');
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewCampaign = false;
                });
        },

        updateCampaignImage({ commit, state }, img) {
            if (!state.idToken) {
                return;
            }
            commit('setCampaignImage', img);
        },

        updateSelectedCampaignIndex({ commit }, index) {
            commit('updateSelectedCampaignIndex', index);
        },

        updateSelectedSpeciesIndex({ commit }, index) {
            commit('updateSelectedSpeciesIndex', index);
        },

        updateSelectedUserIndex({ commit }, index) {
            commit('updateSelectedUserIndex', index);
        },

        updateSelectedClientIndex({ commit }, index) {
            commit('updateSelectedClientIndex', index);
        },

        updateSelectedPlanIndex({ commit }, index) {
            commit('updateSelectedPlanIndex', index);
        },

        updateSelectedCourseIndex({ commit }, index) {
            commit('updateSelectedCourseIndex', index);
        },

        deleteUser({ dispatch, state }, userID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            //PENDIENTE: Checar si el '/0/' del request de abajo está bien:

            axios
                .delete('/users/deleteUser/' + userID + '/0/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        deleteClient({ dispatch, state }, clientID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/clients/deleteClient/' + clientID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los clientes:
                    dispatch('fetchClients');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        deleteCampaign({ dispatch, state }, campaignID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/campaigns/deleteCampaign/' + campaignID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las campañas:
                    dispatch('fetchCampaigns');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        deleteSpecies({ dispatch, state }, speciesID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/species/deleteSpecies/' + speciesID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las especies:
                    dispatch('fetchSpecies');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        getSpeciesData({ commit, dispatch, state }, speciesID) {
            state.bWaitCursor = true;
            axios
                .get('/species/getSpeciesName/' + speciesID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    commit('setSpeciesNames', []);
                    commit('setBreedsLang', []);

                    console.log('getSpeciesData, res = ', res);
                    const especiesIdiomas = res.data;
                    console.log('especiesIdiomas = ', especiesIdiomas);

                    if (especiesIdiomas !== undefined) {
                        commit('setSpeciesNames', especiesIdiomas);

                        //Obtiene todas las razas de la especie en todos los idiomas:

                        axios
                            .get('/breed/getBreedsBySpecies/' + speciesID + '/' + state.idToken, {
                                crossDomain: true
                            })
                            .then(res => {
                                console.log('getBreedsBySpecies, res = ', res);
                                const preRazasIdiomas = res.data;
                                console.log('preRazasIdiomas = ', preRazasIdiomas);

                                if (preRazasIdiomas !== undefined) {
                                    var razasIdiomas = [];
                                    for (var i = 0; i < preRazasIdiomas.length; i++) {
                                        for (var j = 0; j < preRazasIdiomas[i].razas.length; j++) {
                                            var razaIdioma = {
                                                razaid: preRazasIdiomas[i].razaid,
                                                idiomaid: preRazasIdiomas[i].razas[j].idiomaid,
                                                raza: preRazasIdiomas[i].razas[j].raza
                                            };

                                            console.log('razaIdioma = ', razaIdioma);

                                            razasIdiomas.push(razaIdioma);
                                        }
                                    }
                                    commit('setBreedsLang', razasIdiomas);
                                    dispatch('createSpeciesInfo');
                                }
                            });
                    }
                });

            //Pruebas:

            // const razasIdiomas = [
            //     {
            //         razaid: 1,
            //         idiomaid: 1,
            //         raza: 'Akita Americano'
            //     },
            //     {
            //         razaid: 1,
            //         idiomaid: 2,
            //         raza: 'American Akita'
            //     },
            //     {
            //         razaid: 2,
            //         idiomaid: 1,
            //         raza: 'Antiguo Perro de Muestra Danés'
            //     },
            //     {
            //         razaid: 2,
            //         idiomaid: 2,
            //         raza: 'Old Danish Pointer'
            //     },
            //     {
            //         razaid: 3,
            //         idiomaid: 1,
            //         raza: 'Antiguo Pastor Inglés'
            //     },
            //     {
            //         razaid: 3,
            //         idiomaid: 2,
            //         raza: 'Old English Sheepdog'
            //     }
            // ];

            // state.bWaitCursor = false;
            // commit('setSpeciesNames', especiesIdiomas);
            // commit('setBreedsLang', razasIdiomas);
            // dispatch('createSpeciesInfo');
            //Fin pruebas
        },

        createSpeciesInfo({ commit, state }) {
            state.bWaitCursor = true;

            //Crea el arreglo para el único renglón que tendrá la tabla con el nombre de la especie
            //y el arreglo para la tabla, con una columna por idioma:

            var nameTable = []; //Arreglo con un solo renglón para la tabla del nombre de la especie.
            //Crea el único renglón para la tabla anterior:
            var nameTableRow = {
                id: 0
            };

            var speciesHeader = []; //Arreglo para el header de la tabla de la especie.
            const columnWidth = 100 / state.speciesNames.length;

            for (let i = 0; i < state.speciesNames.length; i++) {
                var langName = '';
                for (let j = 0; j < state.languages.length; j++) {
                    if (state.speciesNames[i].idiomaid === state.languages[j].idiomaid) {
                        langName = state.languages[j].idioma;
                        break;
                    }
                }
                const column = {
                    text: langName,
                    value: state.speciesNames[i].idiomaid.toString(),
                    sortable: true,
                    width: columnWidth + '%',
                    divider: true
                };

                //Se crea una nueva columna para el arreglo con el id del idioma como nombre de la columna y con el nombre como contenido:
                const idiomaid = state.speciesNames[i].idiomaid;
                nameTableRow[idiomaid] = state.speciesNames[i].especie;

                speciesHeader.push(column);
            }
            nameTable.push(nameTableRow);
            commit('setSpeciesNameTable', nameTable);
            console.log('speciesNameTable = ', nameTable);
            commit('setSpeciesTableHeader', speciesHeader);
            console.log('speciesHeader = ', speciesHeader);

            //Se crea un arreglo temporal con los ids de las razas:
            var breedArray = [];
            for (let i = 0; i < state.breedsLang.length; i++) {
                //Si no se ha agregado la raza al arreglo, se agrega:
                var bFound = false;
                for (let j = 0; j < breedArray.length; j++) {
                    if (breedArray[j] === state.breedsLang[i].razaid) {
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    breedArray.push(state.breedsLang[i].razaid);
                }
            }

            var breedTable = []; //Arreglo para la tabla de las razas.

            for (let i = 0; i < breedArray.length; i++) {
                var breedTableRow = {
                    razaid: breedArray[i]
                };

                for (let j = 0; j < state.breedsLang.length; j++) {
                    if (breedArray[i] === state.breedsLang[j].razaid) {
                        const idiomaid = state.breedsLang[j].idiomaid;
                        breedTableRow[idiomaid] = state.breedsLang[j].raza;
                    }
                }

                breedTable.push(breedTableRow);
            }

            commit('setBreedTable', breedTable);
            console.log('breedTable = ', breedTable);

            state.bWaitCursor = false;
        },

        updateBreedTable({ commit }, breedTable) {
            commit('setBreedTable', breedTable);
        },

        updateBreedsLang({ commit }, breedsLang) {
            commit('setBreedsLang', breedsLang);
        },

        getBreedsSpanish({ commit, dispatch, state }, speciesID) {
            state.bWaitCursor = true;
            // axios
            //     .get('/razas/getRazasEspaniol/' + speciesID + '/' + state.idToken, {
            //         crossDomain: true
            //     })
            //     .then(res => {
            //         commit('setBreedsSpanish', []);

            //         console.log('getBreedsSpanish, res = ', res);
            //         const razasEspaniol = res.data.razasEspecie;

            //         if (especiesIdiomas !== undefined) {
            //             commit('setBreedsSpanish', razasEspaniol);
            //         }
            //     });

            //Pruebas:
            const razasEspaniol = [
                {
                    razaid: 1,
                    raza: 'Akita Americano'
                },
                {
                    razaid: 2,
                    raza: 'Antiguo Perro de Muestra Danés'
                },
                {
                    razaid: 3,
                    raza: 'Antiguo Pastor Inglés'
                }
            ];

            state.bWaitCursor = false;
            commit('setBreedsSpanish', razasEspaniol);
            //Fin pruebas
        },

        searchPendingVaxes({ dispatch, state }, searchData) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            var results = [];
            dispatch('updatePetSearchResults', results);

            axios
                .get(
                    '/users/getPendingVax/' +
                        searchData.estadoid +
                        '/' +
                        searchData.paisid +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('searchPendingVaxes, res = ', res);
                    results = res.data;
                    dispatch('updatePetSearchResults', results);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en searchPendingVaxes, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        searchPendingDewormings({ dispatch, state }, searchData) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            var results = [];
            dispatch('updatePetSearchResults', results);

            axios
                .get(
                    '/users/getPendingUnparasite/' +
                        searchData.estadoid +
                        '/' +
                        searchData.paisid +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('searchPendingDewormings, res = ', res);
                    results = res.data;
                    dispatch('updatePetSearchResults', results);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en searchPendingDewormings, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        searchPets({ dispatch, state }, searchData) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            var results = [];
            dispatch('updatePetSearchResults', results);

            axios
                .post('/pet/getPets/' + state.idToken, searchData)
                .then(res => {
                    console.log('searchPets, res = ', res);
                    results = res.data;
                    dispatch('updatePetSearchResults', results);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en searchPets, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updatePetSearchResults({ commit, state }, results) {
            if (!state.idToken) {
                return;
            }

            commit('setPetSearchResults', results);
        },

        getPet({ dispatch, state }, petID) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/pet/getById/' + petID + '/' + state.idToken)
                .then(res => {
                    console.log('getPet, res = ', res);
                    const pet = res.data;
                    dispatch('updatePetID', petID);
                    dispatch('updatePet', pet);

                    //Obtiene las vacunas:
                    dispatch('getVaccinations', petID);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getPet, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updatePetID({ commit }, id) {
            commit('setPetID', id);
        },

        getPetQRInfo({ dispatch, state }, petToken) {
            state.bWaitCursor = true;

            axios
                //.get('/pet/getQRInfo/' + petToken + '/' + state.idToken)
                .get('/pet/getQRInfo/' + petToken)
                .then(res => {
                    console.log('getPetQRInfo, res = ', res);
                    const petInfo = res.data;
                    dispatch('updatePetQRInfo', petInfo);
                    //Pendiente: establecer error = 1 para código incorrecto, error = 2 para membresía suspendida

                    //if (petInfo.error !== 0) {
                    //dispatch('updatePetQRError', petInfo.error);
                    dispatch('updatePetQRError', 0);
                    //}
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getPetQRInfo, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        changeMemberShipStatus({ dispatch, state }, membershipInfo) {
            state.bWaitCursor = true;

            axios
                .get(
                    '/users/modifyMembership/' +
                        membershipInfo.userID +
                        '/' +
                        membershipInfo.active +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    console.log('changeMemberShipStatus, res = ', res);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en changeMemberShipStatus, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        zoteroTest1({ commit, state }) {
            state.bWaitCursor = true;
            axios.defaults.baseURL = 'https://api.zotero.org';

            axios
                //.get('/users/11744027/items?limit=100', {
                .get('/users/210947/items?start=0&limit=100', {
                    //.get('/users/210947/items', {
                    headers: {
                        //'Zotero-API-Key': 'HdVyPq3qIxPHXwNWWBKS8CZT',
                        'Zotero-API-Key': 'TSHRaNSd527GWTgGhvxJIHGX',
                        'Zotero-API-Version': 3
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('zoteroTest, res = ', res);
                });

            /*axios
                .get('/users/11744027/items/NJU58XYH/fulltext', {
                    headers: {
                        'Zotero-API-Key': 'HdVyPq3qIxPHXwNWWBKS8CZT'
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('zoteroTest, res = ', res);
                });*/
        },

        updateMessageToOwnerRes({ commit }, result) {
            commit('setMessageToOwnerRes', result);
        },

        sendMessageToOwner({ dispatch, state }, message) {
            state.bWaitCursor = true;

            console.log('Message to send: ', message);
            dispatch('updateMessageToOwnerRes', 0);

            axios
                .post('/pet/sendLocationInfo/', message)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de sendMessageToOwner: ', res);
                    const result = res.data;
                    if (result === 1) {
                        dispatch('updateMessageToOwnerRes', 1); //Success
                    } else if (result === 0) {
                        dispatch('updateMessageToOwnerRes', 2); //Error
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        getVaccinations({ dispatch, state }, petID) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/vax/getVaxByPetId/' + petID + '/' + state.idToken)
                .then(res => {
                    console.log('getVaxByPetId, res = ', res);
                    const vaxes = res.data;

                    //Si el usuario es premium, se checa si hay vacunas sin clasificar:
                    if (state.pet.tipoUsuario === 'Premium') {
                        for (let i = 0; i < vaxes.length; i++) {
                            if (vaxes[i].vacuna === '') {
                                vaxes[i].vacuna = '* * * por clasificar * * *';
                            }
                        }
                    }
                    dispatch('updatePetVaxes', vaxes);

                    //Obtiene las desparasitaciones:
                    dispatch('getDewormings', petID);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getVaxByPetId, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        saveVax({ state }, vaxToEdit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .post('/vax/modifyVax/' + state.idToken, vaxToEdit)
                .then(res => {
                    //console.log("modifyVax, res = ", res);
                    state.bWaitCursor = false;

                    //Actualiza la vacuna localmente:
                    for (let i = 0; i < state.petVaxes.length; i++) {
                        if (state.petVaxes[i].vacunaid === vaxToEdit.vacunaid) {
                            state.petVaxes[i].vacuna = vaxToEdit.vacuna;
                            state.petVaxes[i].aplicacion = vaxToEdit.aplicacion;
                            state.petVaxes[i].expiracion = vaxToEdit.expiracion;
                            state.petVaxes[i].marca = vaxToEdit.marca;
                            state.petVaxes[i].lote = vaxToEdit.lote;
                            break;
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        saveDeworming({ state }, despToEdit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .post('/unparasite/modifyUnparasite/' + state.idToken, despToEdit)
                .then(res => {
                    console.log('saveDeworming, res = ', res);
                    state.bWaitCursor = false;

                    //Actualiza la desparasitación localmente:
                    for (let i = 0; i < state.petDewormings.length; i++) {
                        if (
                            state.petDewormings[i].desparasitacionid ===
                            despToEdit.desparasitacionid
                        ) {
                            state.petDewormings[i].medicamento = despToEdit.medicamento;
                            state.petDewormings[i].aplicacion = despToEdit.aplicacion;
                            state.petDewormings[i].expiracion = despToEdit.expiracion;
                            state.petDewormings[i].marca = despToEdit.marca;
                            state.petDewormings[i].lote = despToEdit.lote;
                            break;
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        getDewormings({ dispatch, state }, petID) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/unparasite/getUnparasiteByPetId/' + petID + '/' + state.idToken)
                .then(res => {
                    console.log('getUnparasiteByPetId, res = ', res);
                    const dewormings = res.data;

                    //Si el usuario es premium, se checa si hay desparasitaciones sin clasificar:
                    if (state.pet.tipoUsuario === 'Premium') {
                        for (let i = 0; i < dewormings.length; i++) {
                            if (dewormings[i].medicamento === '') {
                                dewormings[i].medicamento = '* * * por clasificar * * *';
                            }
                        }
                    }
                    dispatch('updatePetDewormings', dewormings);

                    //Obtiene las limpiezas dentales:
                    dispatch('getDentalCleanings', petID);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getUnparasiteByPetId, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        getDentalCleanings({ dispatch, state }, petID) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/dentalCare/getDentalCareByPetId/' + petID + '/' + state.idToken)
                .then(res => {
                    console.log('getDentalCareByPetId, res = ', res);
                    const dentalCleanings = res.data;
                    dispatch('updatePetDentalCleanings', dentalCleanings);

                    //Obtiene otros procedimientos:
                    dispatch('getOtherProcedures', petID);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getDentalCareByPetId, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        getOtherProcedures({ dispatch, state }, petID) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/other/getOtherByPetId/' + petID + '/' + state.idToken)
                .then(res => {
                    console.log('getOtherByPetId, res = ', res);
                    const procedures = res.data;
                    dispatch('updatePetOtherProcedures', procedures);

                    state.bShowPetDlg = true;
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getOtherByPetId, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updatePetVaxes({ commit, state }, vaxes) {
            if (!state.idToken) {
                return;
            }
            commit('setPetVaxes', vaxes);
        },

        updatePetDewormings({ commit, state }, dewormings) {
            if (!state.idToken) {
                return;
            }
            commit('setPetDewormings', dewormings);
        },

        updatePetDentalCleanings({ commit, state }, dentalCleanings) {
            if (!state.idToken) {
                return;
            }
            commit('setPetDentalCleanings', dentalCleanings);
        },

        updatePetOtherProcedures({ commit, state }, otherProcedures) {
            if (!state.idToken) {
                return;
            }
            commit('setPetOtherProcedures', otherProcedures);
        },

        updatePet({ commit, state }, pet) {
            if (!state.idToken) {
                return;
            }
            commit('setPet', pet);
        },

        updatePetQRInfo({ commit }, petInfo) {
            commit('setPetQRInfo', petInfo);
        },

        updatePetQRError({ commit }, error) {
            commit('setPetQRError', error);
        },

        updatePetQRInfoLoaded({ commit }, loaded) {
            commit('setPetQRInfoLoaded', loaded);
        },

        updateSpecies({ commit, state }, species) {
            if (!state.idToken) {
                return;
            }
            commit('setSpecies', species);
        },

        updateDlgSearchNewVet({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setDlgSearchNewVet', payload);
        },

        updateDlgEditVet({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setDlgEditVet', payload);
        },

        updateDlgAddVet({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setDlgAddVet', payload);
        },

        updateShowPetDlg({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setShowPetDlg', payload);
        },

        updateShowVaxDlg({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setShowVaxDlg', payload);
        },

        updateShowDespDlg({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setShowDespDlg', payload);
        },

        async getVaxImg({ commit, state }, imgInfo) {
            //Se obtiene la imagen de una vacuna:
            state.vaxImg = require('@/assets/no-photo.png');
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/downloadFile/' + imgInfo.fileDownloadUri + '/' + state.idToken, {
                    crossDomain: true,
                    responseType: 'blob'
                })
                .then(res => {
                    state.bWaitCursor = false;
                    let imgFile = new File([res.data], imgInfo.fileName, {
                        type: imgInfo.fileType
                    });
                    var imgFileURL = URL.createObjectURL(imgFile);
                    commit('setVaxImg', imgFileURL);
                });
        },

        async getDespImg({ commit, state }, imgInfo) {
            //Se obtiene la imagen de una desparasitación:
            state.despImg = require('@/assets/no-photo.png');
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            console.log('En getDespImg, imgInfo = ', imgInfo);

            axios
                .get('/downloadFile/' + imgInfo.fileDownloadUri + '/' + state.idToken, {
                    crossDomain: true,
                    responseType: 'blob'
                })
                .then(res => {
                    state.bWaitCursor = false;
                    let imgFile = new File([res.data], imgInfo.fileName, {
                        type: imgInfo.fileType
                    });
                    var imgFileURL = URL.createObjectURL(imgFile);
                    commit('setDespImg', imgFileURL);
                });
        },

        updateVaxImg({ commit, state }, img) {
            if (!state.idToken) {
                return;
            }
            commit('setVaxImg', img);
        },

        updateDespImg({ commit, state }, img) {
            if (!state.idToken) {
                return;
            }
            commit('setDespImg', img);
        },

        updateVaxDlgWidth({ commit, state }, width) {
            if (!state.idToken) {
                return;
            }
            commit('setVaxDlgWidth', width);
        },

        updateDespDlgWidth({ commit, state }, width) {
            if (!state.idToken) {
                return;
            }
            commit('setDespDlgWidth', width);
        }
    },

    getters: {
        version: state => {
            return state.version;
        },
        appTitle: state => {
            return state.appTitle;
        },
        logo1: state => {
            return state.logo1;
        },
        mainBackgroundImg: state => {
            return state.mainBackgroundImg;
        },
        waitCursor: state => {
            return state.bWaitCursor;
        },
        failedLogin: state => {
            return state.bFailedLogin;
        },
        inactiveUser: state => {
            return state.bInactiveUser;
        },
        isAuthenticated(state) {
            return state.idToken !== null && state.idToken !== undefined;
        },
        duplicatedUserError(state) {
            return state.bDuplicatedUserError;
        },
        duplicatedSpeciesError(state) {
            return state.bDuplicatedSpeciesError;
        },
        duplicatedClientError(state) {
            return state.bDuplicatedClientError;
        },
        duplicatedCampaignError(state) {
            return state.bDuplicatedCampaignError;
        },
        user(state) {
            return state.user;
        },
        userID(state) {
            return state.user.usuarioid;
        },
        userName(state) {
            return state.userName;
        },

        loggedUserID(state) {
            return state.userID;
        },

        userType(state) {
            return state.user.tipoid;
        },

        isAdmin(state) {
            return state.bAdmin;
            //return false;
        },

        userTypes(state) {
            return state.userTypes;
        },
        selectedUserTypeIndex: state => {
            return state.selectedUserTypeIndex;
        },

        serverResponse(state) {
            return state.bServerResponse;
        },

        users(state) {
            return state.users;
        },
        administrators(state) {
            return state.administrators;
        },
        clients(state) {
            return state.clients;
        },
        campaigns(state) {
            return state.campaigns;
        },
        campaignImage(state) {
            return state.campaignImage;
        },
        selectedUserIndex: state => {
            return state.selectedUserIndex;
        },
        selectedClientIndex: state => {
            return state.selectedClientIndex;
        },
        selectedCampaignIndex: state => {
            return state.selectedCampaignIndex;
        },
        selectedSpeciesIndex: state => {
            return state.selectedSpeciesIndex;
        },
        selectedPlanIndex: state => {
            return state.selectedPlanIndex;
        },
        selectedCourseIndex: state => {
            return state.selectedCourseIndex;
        },

        species: state => {
            return state.species;
        },

        newSpeciesID: state => {
            return state.newSpeciesID;
        },

        selectNewSpecies: state => {
            return state.selectNewSpecies;
        },

        loadingData(state) {
            return state.bLoadingData;
        },

        languages: state => {
            return state.languages;
        },
        selectedLanguageIndex: state => {
            return state.selectedLanguageIndex;
        },
        speciesNames(state) {
            return state.speciesNames;
        },
        speciesNameTable(state) {
            return state.speciesNameTable;
        },
        speciesTableHeader(state) {
            return state.speciesTableHeader;
        },
        breedTable(state) {
            return state.breedTable;
        },
        breedsLang(state) {
            return state.breedsLang;
        },
        countries(state) {
            return state.countries;
        },
        states(state) {
            return state.states;
        },
        specialties(state) {
            return state.specialties;
        },
        vets(state) {
            return state.vets;
        },
        vetsLoaded(state) {
            return state.vetsLoaded;
        },
        dlgSearchNewVet(state) {
            return state.bDlgSearchNewVet;
        },
        dlgEditVet(state) {
            return state.bDlgEditVet;
        },
        dlgAddVet(state) {
            return state.bDlgAddVet;
        },
        breedsSpanish(state) {
            return state.breedsSpanish;
        },
        petSearchResults(state) {
            return state.petSearchResults;
        },
        petID(state) {
            return state.petID;
        },
        pet(state) {
            return state.pet;
        },
        petQRInfo(state) {
            return state.petQRInfo;
        },
        petQRInfoLoaded(state) {
            return state.petQRInfoLoaded;
        },
        petQRError(state) {
            return state.petQRError;
        },
        petVaxes(state) {
            return state.petVaxes;
        },
        petDewormings(state) {
            return state.petDewormings;
        },
        petDentalCleanings(state) {
            return state.petDentalCleanings;
        },
        petOtherProcedures(state) {
            return state.petOtherProcedures;
        },
        showPetDlg(state) {
            return state.bShowPetDlg;
        },
        showVaxDlg(state) {
            return state.bShowVaxDlg;
        },
        showDespDlg(state) {
            return state.bShowDespDlg;
        },
        vaxImg(state) {
            return state.vaxImg;
        },
        despImg(state) {
            return state.despImg;
        },
        vaxDlgWidth(state) {
            return state.vaxDlgWidth;
        },
        despDlgWidth(state) {
            return state.despDlgWidth;
        },
        messageToOwnerRes(state) {
            return state.messageToOwnerRes;
        }
    }
});
